import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';

function Privacy() {
  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ fontWeight: 600 }}>
        Privacy Policy
      </Typography>
      <Typography variant="subtitle1" align="center" color="text.secondary" gutterBottom>
        Last Updated: {new Date().toLocaleDateString()}
      </Typography>
      
      <Paper elevation={2} sx={{ p: 4, borderRadius: 2, mt: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          1. Information We Collect
        </Typography>
        <Typography variant="body1" paragraph>
          We collect personal information that you provide to us, including your name, email address, facial image, 
          and any medical documents you upload. We also collect information about your use of our service.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          2. How We Use Your Information
        </Typography>
        <Typography variant="body1" paragraph>
          We use your information to provide and improve our service, to authenticate your identity, to store and 
          retrieve your medical documents, and to communicate with you about our service.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          3. Information Sharing
        </Typography>
        <Typography variant="body1" paragraph>
          We share your information with emergency medical personnel who use our service to access your advance directives. 
          We may also share your information with service providers who help us operate our service, and as required by law.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          4. Data Security
        </Typography>
        <Typography variant="body1" paragraph>
          We implement appropriate security measures to protect your personal information. However, no method of 
          transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          5. Your Rights
        </Typography>
        <Typography variant="body1" paragraph>
          You have the right to access, correct, or delete your personal information. You can exercise these rights 
          by contacting us at support@check4dnr.com.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          6. HIPAA Compliance
        </Typography>
        <Typography variant="body1" paragraph>
          As a service that handles protected health information, we comply with the Health Insurance Portability and 
          Accountability Act (HIPAA). We maintain appropriate safeguards to protect the privacy and security of your health information.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          7. Changes to This Policy
        </Typography>
        <Typography variant="body1" paragraph>
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new 
          Privacy Policy on this page and updating the "Last Updated" date.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          8. Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about this Privacy Policy, please contact us at support@check4dnr.com.
        </Typography>
      </Paper>
    </Container>
  );
}

export default Privacy;